__turbopack_context__.v({
  "className": "ivyoradisplay_aeaf345a-module__8lm_AW__className",
  "variable": "ivyoradisplay_aeaf345a-module__8lm_AW__variable",
});
